import { PillMultipleIcon } from './PillMultipleIcon';

/**
 * author: Hans Böhm
 * id F4398329-8140-4053-A17D-D96501E7C467
 * name pill-multiple
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pill-multiple.svg
 * tags
 * - Medical / Hospital 
 */
export const DrugsIcon = PillMultipleIcon;
export default DrugsIcon